// extracted by mini-css-extract-plugin
module.exports = {"input":"SimpleForm_input__19fbb","last":"SimpleForm_last__WWTUl","form":"SimpleForm_form__1SLeu"};